import { useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import AnimatedLogo from "./AnimatedLogo";
import { scrollToId } from "../lib/scroll";

const LINKS = [
  { id: "services", label: "Services", testId: "nav-link-services" },
  { id: "manifesto", label: "Why Us", testId: "nav-link-manifesto" },
  { id: "clients", label: "Clients", testId: "nav-link-clients" },
  { id: "pricing", label: "Pricing", testId: "nav-link-pricing" },
  { id: "news", label: "News", testId: "nav-link-news" },
  { id: "leadership", label: "About", testId: "nav-link-about" },
];

const Navbar = ({ onViewInquiries }) => {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      data-testid="nav-header-container"
      className="fixed top-0 inset-x-0 z-50 border-b border-slate-200 bg-white/85 backdrop-blur-xl"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex h-[72px] items-center justify-between gap-4">
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex items-center gap-2.5 shrink-0"
            aria-label="Artwork360 home"
          >
            <AnimatedLogo className="h-9 w-9" testId="nav-artwork360-logo" />
            <img
              src="/logo-wide-nav.png"
              alt="Artwork360"
              data-testid="nav-artwork360-wordmark"
              className="h-9 w-auto object-contain"
            />
          </button>

          <nav className="hidden lg:flex items-center gap-7">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={l.testId}
                onClick={() => go(l.id)}
                className="font-mono2 text-[11px] uppercase tracking-[0.22em] text-slate-500 transition-colors duration-300 hover:text-[#2E3192]"
              >
                {l.label}
              </button>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <button
              data-testid="nav-view-inquiries-button"
              onClick={onViewInquiries}
              className="rounded-full border border-slate-300 px-4 py-2 text-xs font-semibold text-slate-600 transition-colors duration-300 hover:border-[#6DC8F0]/60 hover:text-[#2E3192]"
            >
              View Inquiries
            </button>
            <button
              data-testid="nav-cta-contact-button"
              onClick={() => go("contact")}
              className="group flex items-center gap-1.5 rounded-full bg-[#2E3192] px-5 py-2 text-xs font-semibold text-white transition-colors duration-300 hover:bg-[#6DC8F0] hover:text-[#07090E]"
            >
              Get in Touch
              <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>
          </div>

          <button
            className="lg:hidden text-slate-700"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
            data-testid="nav-mobile-menu-button"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-[#F8FAFC] px-5 py-6" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-4">
            {LINKS.map((l) => (
              <button
                key={l.id}
                onClick={() => go(l.id)}
                className="text-left font-mono2 text-xs uppercase tracking-[0.22em] text-slate-600"
              >
                {l.label}
              </button>
            ))}
            <button
              onClick={() => {
                setOpen(false);
                onViewInquiries();
              }}
              className="text-left font-mono2 text-xs uppercase tracking-[0.22em] text-[#2E3192]"
            >
              View Inquiries
            </button>
            <button
              onClick={() => go("contact")}
              className="mt-2 rounded-full bg-[#2E3192] px-5 py-3 text-sm font-semibold text-white"
            >
              Get in Touch
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
